import { EWorldMapSetType } from '__generated__/globalTypes';
import { EColors, EFonts, EGrads, EHovers } from 'libs/styles/styling';
import { sortBy } from 'lodash';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MinuteFloors = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    const floors = sortBy(
        ctxEdit.map.worldMapSets.filter((e) => e.type === EWorldMapSetType.FLOOR) ?? [],
        (e) => e.orderIndex
    );
    const floorIds = floors.map((e) => e.worldMapSetId);

    function changeFloor(floorId: string) {
        const visibleIdsWithoutFloor = ctxEdit.visibleMapSetIds.filter(
            (e) => !floorIds.includes(e)
        );

        ctxEdit.setVisibleMapSetIds([...visibleIdsWithoutFloor, floorId]);
    }

    return (
        <S_MinuteFloors className={props.className}>
            <S_FloorButtons>
                {floors.map((e) => {
                    return (
                        <S_Floor
                            key={e.worldMapSetId}
                            $selected={ctxEdit.visibleMapSetIds.includes(e.worldMapSetId)}
                            onClick={() => changeFloor(e.worldMapSetId)}
                        >
                            {e.title}
                        </S_Floor>
                    );
                })}
            </S_FloorButtons>
        </S_MinuteFloors>
    );
};

const S_MinuteFloors = styled.div``;

const S_FloorButtons = styled.div`
    display: flex;
    border-radius: 7px;
    background: #efefef;
    font-family: ${EFonts.Regular};
    color: #141c54;
    font-size: 13px;
`;

const S_Floor = styled.div<{ $selected: boolean }>`
    width: 100px;
    height: 42px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 5px 8px;
    cursor: pointer;
    box-shadow: ${EHovers.LIGHT1};
    &:hover {
        background-color: ${EColors.GREY5};
    }
    ${(props) => {
        if (props.$selected) {
            return `
            color: ${EColors.WHITE};
            background: ${EGrads.ACC2_GRAD};
            `;
        }
    }}
    &:first-child {
        border-radius: 7px 0 0 7px;
    }
    &:last-child {
        border-radius: 0 7px 7px 0;
    }
    &:first-child:last-child {
        border-radius: 7px;
    }
`;
